<!-- eslint-disable style/max-len -->
<template>
  <svg width="84" height="84" viewBox="0 0 84 84" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="84" height="84" rx="42" fill="#FCE9E7" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M31.9393 31.9393C32.5251 31.3536 33.4749 31.3536 34.0607 31.9393L42 39.8787L49.9393 31.9393C50.5251 31.3536 51.4749 31.3536 52.0607 31.9393C52.6464 32.5251 52.6464 33.4749 52.0607 34.0607L44.1213 42L52.0607 49.9393C52.6464 50.5251 52.6464 51.4749 52.0607 52.0607C51.4749 52.6464 50.5251 52.6464 49.9393 52.0607L42 44.1213L34.0607 52.0607C33.4749 52.6464 32.5251 52.6464 31.9393 52.0607C31.3536 51.4749 31.3536 50.5251 31.9393 49.9393L39.8787 42L31.9393 34.0607C31.3536 33.4749 31.3536 32.5251 31.9393 31.9393Z"
      fill="#BD133C"
    />
  </svg>
</template>
